import * as API from "utils/api"

const getUserPositionSuccess = userposition => ({
  type: "GET_USER_POSITION_SUCCESS",
  userposition,
})


export const getUserPosition = () => async dispatch => {
  const position = await getPosition()
  if(position.coords) {
  const config = {
    body: JSON.stringify({
      latitude: position.coords.latitude,
      longitude: position.coords.longitude,
    }),
  }
  const response = await API.post(`/geocode`, config)
  const data = await response.json()
  const userposition = data.results["0"].components.County
  dispatch(getUserPositionSuccess(userposition));
  }
}

function getPosition() {
  return new Promise((res, rej) => {
    navigator.geolocation.getCurrentPosition(res, rej)
  }).catch(error => {return error})
}



// WEBPACK FOOTER //
// src/data/userposition/actions.js